import React, { useState, useEffect } from "react";
import {
  TextArea,
  NumericTextBox,
  Input,
  Checkbox,
} from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";
import { useSelector, useDispatch } from "react-redux";
import MattersCombobox from "../Postings/MattersComboBox";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import MatterAccount from "../MatterLedger/MatterAccount";
import {
  clearMattersBalances,
  getMattersBalances,
  getMattersInfo,
} from "actions/matters.action";
import {
  getChitRequest,
  updateChitRequest,
  createChitRequest as createChitRequestAPI,
  getMattersdetails,
  getMatterDefaults,
} from "api";
import { rejectChitRequest } from "api/accountsAPI";
import { toast } from "react-toastify";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import { useActiveFeeEarner } from "services/userService";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { ComboBoxComponent } from "./ChitRequestComponents";
import styles from "./ChitRequest.module.scss";
import { useActiveVats } from "services/vatService";
import { useActiveBranches } from "services/branchService";
import { getPostingTypes } from "services/postingTypesService";
import { useActiveSuppliers } from "services/supplierService";
import { useNominalsBySubType } from "services/nominalsService";
import chitRequestFieldsConfig from "./chit_request_fields.json";

const MatterDetails = ({ matter, clear }) => {
  if (!matter) return;
  return (
    <>
      <div>
        <div
          style={{
            color: "gray",
          }}
          className="fs-md fw-semibold"
        >
          {clear ? "" : matter?.branch}
        </div>
        <div className="fw-bold">
          {clear ? "" : matter?.details}
          {matter?.matterRef} {clear ? "" : ` - ${matter?.clientName}` || ""}
        </div>
      </div>
    </>
  );
};

const ChitRequest = (props) => {
  const IS_MODAL = props.component === "modal";
  const IS_UNALLOCATED_CREATE =
    IS_MODAL &&
    Boolean(props.activityData?.unallocatedOnly) &&
    !props.activityData?.chitRequestId;
  const [list, setList] = useState([]);
  const [validator, setValidator] = useState({});
  const { data: activevatsdata = [] } = useActiveVats();
  const [loading, setLoading] = useState(false);
  const [resetDocs, setresetDocs] = useState(false);
  const { data: branchesList } = useActiveBranches();
  const { data: feeearnerdata } = useActiveFeeEarner();
  const [postingTypes, setPostingTypes] = useState([]);

  // New nominals service hooks
  const { data: expenseNominals } = useNominalsBySubType(
    "ProfitAndLoss_Expense"
  );
  const { data: officeBankNominals } = useNominalsBySubType(
    "BalanceSheet_OfficeBank"
  );
  const { data: clientBankNominals } = useNominalsBySubType(
    "BalanceSheet_ClientBank"
  );
  const { data: ddaBankNominals } = useNominalsBySubType(
    "BalanceSheet_DDABank"
  );
  const date = new Date();
  const [type, settype] = useState("");
  const [vatvalue, setvatvalue] = useState();
  const [matterref, setmatterref] = useState(
    IS_MODAL ? props.matter?.matterId ?? null : null,
  );
  const [feeearnerref, setfeeearnerref] = useState();
  const [matterBalanceClear, setMatterBalanceClear] = useState(false);
  const [matter, setMatter] = useState(
    IS_MODAL ? props.matter ?? null : null,
  );
  const [branch, setbranch] = useState({ branchId: "" });
  const [nominal, setnominal] = useState({ nominalRef: "" });
  const [suppliervalue, setsuppliervalue] = useState({ supplierRef: "" });
  const [errorModal, setErrorModal] = useState(false);
  const [officevalue, setofficevalue] = useState("");
  const [clientvalue, setclientvalue] = useState("");
  const [ddavalue, setddavalue] = useState("");
  const [state, setstate] = useState("");
  const [payee, setpayee] = useState("");
  const [payer, setpayer] = useState("");
  const [vatamount, setvatamount] = useState();
  const [netamount, setnetamount] = useState(0);
  const [grossamount, setgrossamount] = useState("");
  const [resetmatter, setresetmatter] = useState(false);
  const [details, setdetails] = useState("");
  const [bankName, setBankName] = useState("");
  const [sortCode, setSortCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [dateselector, setdateselector] = useState(date);
  const { data: suppliersdata } = useActiveSuppliers();
  const [counselfee, setcounselfee] = useState(false);
  const [validation_message, setvalidation_message] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isRejectedChit, setIsRejectedChit] = useState(
    Boolean(props.activityData?.rejected || props.activityData?.isRejected),
  );
  const [documentUpload, setDocumentsUpload] = useState(false);
  const [vatsdata, setvatsData] = useState();
  const [feeearner, setfeeearnerData] = useState();
  const [branchesdata, setbranchesdata] = useState();
  const [suppliers, setsuppliersdata] = useState([]);
  // Initialize loading state based on whether we need to fetch chit data
  const [isLoadingChitData, setIsLoadingChitData] = useState(
    IS_MODAL && props.activityData?.chitRequestId ? true : false
  );

  const mattersBalances = useSelector((state) => state.mattersList);

  const normalizeFields = (postingCode) => {
    const postingType = chitRequestFieldsConfig.data.find(
      (pt) => pt.code === postingCode
    );

    const displayFields = postingType.displayFields;

    // Build list directly from JSON
    const list = displayFields.map((f) => f.name);

    // Build validator directly from JSON
    const validator = {};
    displayFields.forEach((f) => {
      validator[f.name] = f.displayName;
    });

    return { list, validator };
  };

  const fetchData = async () => {
    try {
      const postingData = await getPostingTypes("chits", {
        unallocated:
          Boolean(props?.activityData?.unallocatedOnly) &&
          !props?.activityData?.chitRequestId,
      });
      if (!Array.isArray(postingData) || postingData.length === 0) return;

      if (!props?.activityData?.chitRequestId) {
        const defaultType = postingData[0];
        settype(defaultType);
        const { list, validator } = normalizeFields(defaultType.code);
        setList(list);
        setValidator(validator);
      } else {
        const { list, validator } = normalizeFields(postingData[0].code);
        setList(list);
        setValidator(validator);
      }
      setPostingTypes(postingData);
    } catch (error) {
      console.error("Failed to fetch posting types:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [props.name]);

  useEffect(() => {
    setLoading(true);
    if (
      list?.length > 0 &&
      IS_MODAL &&
      mattersBalances?.mattersChitRequest?.data?.matterRef !== undefined
    ) {
      setLoading(false);
    } else if (list?.length > 0) {
      setLoading(false);
    }
  }, [list]);

  const dispatch = useDispatch();

  const onChangesupplier = (event) => {
    if (event !== undefined && event !== null) {
      setsuppliervalue(event.value);
    }
  };
  const onChangeofficebank = (event) => {
    if (event !== undefined && event !== null) {
      setofficevalue(event.value);
    }
  };
  const onChangeclientbank = (event) => {
    if (event !== undefined && event !== null) {
      setclientvalue(event.value);
    }
  };
  const onChangeddabank = (event) => {
    if (event !== undefined && event !== null) {
      setddavalue(event.value);
    }
  };
  useEffect(() => {
    const matterId = props?.matter?.matterId;
    if (IS_MODAL && matterId) {
      dispatch(getMattersBalances(matterId, "Chit Request"));
    }
  }, [IS_MODAL, props?.matter?.matterId, dispatch]);

  // Fetch matter details if missing (for edit mode from ChitPosting)
  useEffect(() => {
    const fetchMatterDetails = async () => {
      if (!IS_MODAL || !props.activityData?.chitRequestId || !matter?.matterId)
        return;

      // Check if matter details are incomplete
      const isMatterIncomplete =
        !matter.details ||
        !matter.clientName ||
        !matter.branch ||
        !matter.feeEarnerName;

      if (isMatterIncomplete) {
        try {
          const response = await getMattersdetails(matter.matterId);
          setMatter((prevMatter) => ({
            ...prevMatter,
            ...response.data?.data,
          }));
        } catch (error) {
          console.error("Error fetching matter details:", error);
        }
      }
    };

    fetchMatterDetails();
  }, [IS_MODAL, props.activityData?.chitRequestId, matter?.matterId]);

  // BatchPosting pattern: populate defaults from existing data (like handleUpdate)
  const populateDefaultsFromChit = (chitData) => {
    if (!chitData) return;
    setIsRejectedChit(Boolean(chitData.rejected || chitData.isRejected));

    // Load matter and balances first (like BatchPosting handleUpdate)
    if (chitData.matterID) {
      onChangematter({ value: chitData.matterID });
    }

    // Set all form fields from existing data (BatchPosting pattern)
    chitData.details && setdetails(chitData.details);
    chitData.date && setdateselector(new Date(chitData.date));
    chitData.reference && setstate(chitData.reference);
    chitData.netAmount !== undefined && setnetamount(chitData.netAmount);
    chitData.vatAmount !== undefined && setvatamount(chitData.vatAmount);
    chitData.payee && setpayee(chitData.payee);
    chitData.payer && setpayer(chitData.payer);
    chitData.bankName && setBankName(chitData.bankName);
    chitData.bankSortCode && setSortCode(chitData.bankSortCode);
    chitData.bankAccountNo && setAccountNumber(chitData.bankAccountNo);
    chitData.notes && setNotes(chitData.notes);
    chitData.isCounselFee !== undefined && setcounselfee(chitData.isCounselFee);

    // Set complex objects
    chitData.supplierRef &&
      setsuppliervalue({ supplierRef: chitData.supplierRef });
    chitData.nominalRef && setnominal({ nominalRef: chitData.nominalRef });
    chitData.branchId && setbranch({ branchId: chitData.branchId });
    chitData.officeBank && setofficevalue({ nominalRef: chitData.officeBank });
    chitData.clientBank && setclientvalue({ nominalRef: chitData.clientBank });
    chitData.ddaBank && setddavalue({ nominalRef: chitData.ddaBank });

    // Store references for later processing when data becomes available
    chitData.feeEarnerRef && setfeeearnerref(chitData.feeEarnerRef);

    // Set VAT code
    if (chitData.vatCode && activevatsdata?.length > 0) {
      const vatValue = activevatsdata.find(
        (item) => item.vatCodeId === chitData.vatCode
      );
      if (vatValue) setvatvalue(vatValue);
    }

    // Set posting type and update list/validator
    if (chitData.postingType && postingTypes?.length > 0) {
      const matchingPostingType = postingTypes.find(
        (pt) => pt.code === chitData.postingType
      );
      if (matchingPostingType) {
        settype(matchingPostingType);
        const { list, validator } = normalizeFields(matchingPostingType.code);
        setList(list);
        setValidator(validator);
      }
    }
  };

  useEffect(() => {
    setIsRejectedChit(
      Boolean(props.activityData?.rejected || props.activityData?.isRejected),
    );
  }, [props.activityData]);

  // Handle prefilling data from activity (for edit mode) - BatchPosting pattern
  useEffect(() => {
    const fetchAndPrefillChitData = async () => {
      if (!props.activityData || !IS_MODAL) return;

      // Wait for posting types to be loaded before fetching chit data
      if (postingTypes.length === 0) return;

      if (
        props.activityData.unallocatedOnly &&
        !props.activityData.chitRequestId
      ) {
        setIsLoadingChitData(false);
        return;
      }

      if (props.activityData.chitRequestId) {
        try {
          const response = await getChitRequest(
            props.activityData.chitRequestId
          );
          const chitData = response.data?.data;
          if (chitData) {
            // Use BatchPosting pattern - populate all defaults from existing data
            populateDefaultsFromChit(chitData);
          }
        } catch (error) {
          console.error("Error fetching chit data:", error);
        } finally {
          setIsLoadingChitData(false);
        }
      } else {
        // Fallback: prefill with basic activity data if no chitRequestId
        const basicData = {
          details: props.activityData.details,
          date: props.activityData.date,
          feeEarnerRef: props.activityData.feeEarnerRef,
        };
        populateDefaultsFromChit(basicData);
        setIsLoadingChitData(false);
      }
    };

    fetchAndPrefillChitData();
  }, [
    props.activityData?.chitRequestId,
    props.activityData?.unallocatedOnly,
    IS_MODAL,
    postingTypes,
  ]);

  useEffect(() => {
    if (
      feeearnerdata?.length > 0 &&
      feeearnerref &&
      typeof feeearnerref === "string"
    ) {
      // Convert feeEarnerRef string to feeEarner object
      const matchingFeeEarner = feeearnerdata.find(
        (fe) => fe.userRef === feeearnerref
      );
      if (matchingFeeEarner) {
        setfeeearnerref(matchingFeeEarner);
      }
    }
  }, [feeearnerdata, feeearnerref]);

  useEffect(() => {
    if (
      IS_MODAL &&
      matter?.matterId &&
      !props.activityData?.chitRequestId &&
      !vatvalue &&
      !feeearnerref
    ) {
      if (
        activevatsdata?.length > 0 ||
        feeearnerdata?.length > 0 ||
        officeBankNominals?.length > 0 ||
        clientBankNominals?.length > 0 ||
        ddaBankNominals?.length > 0
      ) {
        applyMatterDefaults(matter.matterId);
      }
    }
  }, [matter]);

  useEffect(() => {
    if (
      activevatsdata?.length > 0 &&
      vatvalue &&
      typeof vatvalue.vatCodeId === "number"
    ) {
      // Find matching VAT object from the VAT data array
      const matchingVat = activevatsdata.find(
        (vat) => vat.vatCodeId === vatvalue.vatCodeId
      );
      if (matchingVat && !vatvalue.display) {
        // Update with full VAT object if we only have the ID and rate
        setvatvalue({
          ...vatvalue,
          ...matchingVat,
        });
      }
    }
  }, [activevatsdata, vatvalue]);

  const handleChange = async (event) => {
    // Blocking conditions
    if (props.name === "All Postings" && filesCurrentData[0] !== undefined) {
      setErrorModal(true);
      return;
    }
    if (
      props.name === "Office Postings" &&
      filesCurrentOfficeData[0] !== undefined
    ) {
      setErrorModal(true);
      return;
    }
    if (
      props.name === "Client Postings" &&
      filesCurrentClientData[0] !== undefined
    ) {
      setErrorModal(true);
      return;
    }

    setresetmatter(!resetmatter);
    setvalidation_message(false);
    settype(event.value);

    const { list, validator } = normalizeFields(event.value.code);

    setList(list);
    setValidator(validator);

    // Apply matter defaults when posting type changes (BatchPosting pattern)
    if (matterref && !props.activityData?.chitRequestId) {
      await applyMatterDefaults(matterref);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (
        !suppliersdata?.length ||
        !feeearnerdata?.length ||
        !vatsdata?.length
      ) {
        setvatsData(activevatsdata.slice());
        setfeeearnerData(feeearnerdata.slice());
        setsuppliersdata(suppliersdata.slice());
      }
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [feeearnerdata, activevatsdata, suppliersdata]);

  // BatchPosting pattern: Apply matter defaults from API
  const applyMatterDefaults = async (matterId) => {
    if (!matterId) return;
    try {
      const response = await getMatterDefaults(matterId);
      const defaults = response?.data?.data;

      if (!defaults) return;

      // Apply VAT defaults - always set (either matched value or null)
      if (defaults.defaultVatCodeId && activevatsdata?.length > 0) {
        const matchedVat = activevatsdata.find(
          (v) => v.vatCodeId === defaults.defaultVatCodeId
        );
        setvatvalue(matchedVat || null);
      } else {
        setvatvalue(null);
      }

      // Apply Fee Earner defaults - always set (either matched value or null)
      if (defaults.matterFeeEarner && feeearnerdata?.length > 0) {
        const matchedFeeEarner = feeearnerdata.find(
          (fe) => fe.userRef === defaults.matterFeeEarner
        );
        setfeeearnerref(matchedFeeEarner || null);
      } else {
        setfeeearnerref(null);
      }

      // Apply Office Bank defaults - always set (either matched value or null)
      if (defaults.defaultOfficeBank && officeBankNominals?.length > 0) {
        const matchedOfficeNominal = officeBankNominals.find(
          (n) => n.nominalRef === defaults.defaultOfficeBank
        );
        setofficevalue(
          matchedOfficeNominal
            ? {
              nominalRef: defaults.defaultOfficeBank,
              display: matchedOfficeNominal.display,
            }
            : null
        );
      } else {
        setofficevalue(null);
      }

      // Apply Client Bank defaults - always set (either matched value or null)
      if (defaults.defaultClientBank && clientBankNominals?.length > 0) {
        const matchedClientNominal = clientBankNominals.find(
          (n) => n.nominalRef === defaults.defaultClientBank
        );
        setclientvalue(
          matchedClientNominal
            ? {
              nominalRef: defaults.defaultClientBank,
              display: matchedClientNominal.display,
            }
            : null
        );
      } else {
        setclientvalue(null);
      }

      // Apply DDA Bank defaults - always set (either matched value or null)
      if (defaults.defaultDDABank && ddaBankNominals?.length > 0) {
        const matchedDDANominal = ddaBankNominals.find(
          (n) => n.nominalRef === defaults.defaultDDABank
        );
        setddavalue(
          matchedDDANominal
            ? {
              nominalRef: defaults.defaultDDABank,
              display: matchedDDANominal.display,
            }
            : null
        );
      } else {
        setddavalue(null);
      }
    } catch (error) {
      console.error("Error applying matter defaults:", error);
    }
  };

  const onChangematter = async (e) => {
    if (
      IS_MODAL &&
      !(props.activityData?.unallocatedOnly && !props.activityData?.chitRequestId)
    ) {
      return;
    }
    setMatterBalanceClear(false);
    let event = e.value;
    if (event !== null && event !== undefined) {
      setMatter(event);
      dispatch(getMattersInfo(event.matterId)); // Fetch full matter details
      dispatch(getMattersBalances(event.matterId, "Chit Request"));
      setmatterref(event.matterId);

      // Apply matter defaults from API (BatchPosting pattern)
      if (!props.activityData?.chitRequestId) {
        await applyMatterDefaults(event.matterId);
      }
    } else {
      setmatterref(null);
      setMatter(null);
      setMatterBalanceClear(true);
      dispatch(clearMattersBalances("Chit Request"));
    }
  };

  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };
  const filtersupplier = (filter) => {
    const data = suppliersdata.slice();
    return filterBy(data, filter);
  };
  const filterChangesupplier = (event) => {
    setsuppliersdata(filtersupplier(event.filter));
  };

  const [officedata, setofficedata] = useState([]);
  const [clientdata, setclientdata] = useState([]);
  const [ddadata, setddadata] = useState([]);

  // Initialize nominal data when services load
  useEffect(() => {
    if (officeBankNominals?.length) {
      setofficedata(officeBankNominals.slice());
    }
  }, [officeBankNominals]);

  useEffect(() => {
    if (clientBankNominals?.length) {
      setclientdata(clientBankNominals.slice());
    }
  }, [clientBankNominals]);

  useEffect(() => {
    if (ddaBankNominals?.length) {
      setddadata(ddaBankNominals.slice());
    }
  }, [ddaBankNominals]);

  const filterofficebank = (filter) => {
    const data = officeBankNominals.slice();
    return filterBy(data, filter);
  };
  const filterChangeofficebank = (event) => {
    setofficedata(filterofficebank(event.filter));
  };
  const filterclientbank = (filter) => {
    const data = clientBankNominals.slice();
    return filterBy(data, filter);
  };
  const filterChangeclientbank = (event) => {
    setclientdata(filterclientbank(event.filter));
  };
  const filterddabank = (filter) => {
    const data = ddaBankNominals.slice();
    return filterBy(data, filter);
  };
  const filterChangeddabank = (event) => {
    setddadata(filterddabank(event.filter));
  };
  const filterfeeearnerData = (filter) => {
    const data = feeearnerdata.slice();
    return filterBy(data, filter);
  };
  const filterfeeearner = (event) => {
    setfeeearnerData(filterfeeearnerData(event.filter));
  };
  const [nominaldata, setnominaldata] = useState([]);

  // Initialize expense nominals data when service loads
  useEffect(() => {
    if (expenseNominals?.length) {
      setnominaldata(expenseNominals.slice());
    }
  }, [expenseNominals]);

  const filternominalData = (filter) => {
    const data = expenseNominals.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };
  const filterbranchesData = (filter) => {
    const data = branchesList.slice();
    return filterBy(data, filter);
  };
  const filterbranch = (event) => {
    setbranchesdata(filterbranchesData(event.filter));
  };

  const onChangevat = (event) => {
    setvatvalue(event.value);
  };
  const calculatevatamount = () => {
    if (vatvalue !== undefined && vatvalue !== null) {
      const vatamount = netamount * (vatvalue.rate / 100);
      setvatamount(vatamount);
    }
  };
  useEffect(() => {
    calculatevatamount();
  }, [vatvalue, netamount]);
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };
  const onChangebranch = (event) => {
    setbranch(event.value);
  };
  const onChangenominal = (event) => {
    setnominal(event.value);
  };
  const onChangecounselfee = (event) => {
    setcounselfee(event.value);
  };
  const { files: filesCurrentData } = useFiles(FILES_CONTEXT.ALL_POSTINGS);
  const { files: filesCurrentOfficeData } = useFiles(FILES_CONTEXT.OFFICE_POSTING);
  const { files: filesCurrentClientData } = useFiles(FILES_CONTEXT.CLIENT_POSTING);
  const {
    files: filesChitRequest,
    addFile: addChitFile,
    clearFile: clearChitFile
  } = useFiles(FILES_CONTEXT.CHIT_REQUEST);

  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const noVatPostingCodes = [
      "ODR",
      "OCR",
      "CDR",
      "CCR",
      "DDR",
      "DCR",
    ];

    if (IS_UNALLOCATED_CREATE) {
      const netNum = Number(netamount);
      const netInvalid =
        netamount === "" ||
        netamount === null ||
        netamount === undefined ||
        !Number.isFinite(netNum) ||
        netNum === 0;

      const needsVat =
        list.includes("VatCode") &&
        type?.code &&
        !noVatPostingCodes.includes(type.code);

      if (
        !dateselector ||
        !type?.code ||
        netInvalid ||
        (list.includes("Payee") && !String(payee || "").trim()) ||
        (list.includes("Payer") && !String(payer || "").trim()) ||
        (list.includes("Details") && !String(details || "").trim()) ||
        (list.includes("Reference") && !String(state || "").trim()) ||
        (needsVat && vatvalue === undefined) ||
        (list.includes("FeeEarnerRef") &&
          !feeearnerref?.userRef &&
          typeof feeearnerref !== "string") ||
        (list.includes("SupplierRef") &&
          !String(suppliervalue?.supplierRef || "").trim()) ||
        (list.includes("OfficeBank") && !officevalue?.nominalRef) ||
        (list.includes("ClientBank") && !clientvalue?.nominalRef) ||
        (list.includes("DDABank") && !ddavalue?.nominalRef)
      ) {
        setvalidation_message(true);
        setLoading(false);
        return;
      }
    } else if (
      (type.code !== "ODR" &&
        type.code !== "OCR" &&
        type.code !== "CDR" &&
        type.code !== "CCR" &&
        type.code !== "DDR" &&
        type.code !== "DCR" &&
        vatvalue === undefined) ||
      details === undefined ||
      netamount === 0
    ) {
      setvalidation_message(true);
      setLoading(false);
      return;
    }

    const feeEarnerRefResolved =
      feeearnerref?.userRef ??
      (typeof feeearnerref === "string" ? feeearnerref : undefined);

    let baseData = {
      postingType: type.code,
      reference: state,
      matterID: matterref,
      netAmount: netamount,
      feeEarnerRef: feeEarnerRefResolved,
      date: dateselector,
      currencyCode: "GBP",
      details: details,
      payee: payee,
      payer: payer,
      bankName: bankName,
      bankSortCode: sortCode,
      bankAccountNo: accountNumber,
      notes: notes,
      isCounselFee: counselfee,
      documentFiles: [],
    };

    if (filesChitRequest && filesChitRequest.length > 0) {
      const docsId = filesChitRequest.map((item) => item.fileID);
      baseData.documentFiles = docsId;
    }

    let data = [baseData];
    switch (type.code) {
      case "ODR":
      case "OCR":
        baseData.officeBank = officevalue?.nominalRef;
        break;
      case "DPU":
        baseData.officeBank = officevalue?.nominalRef;
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
      case "CDR":
      case "CCR":
        baseData.clientBank = clientvalue?.nominalRef;
        break;
      case "DDR":
      case "DCR":
        baseData.ddaBank = ddavalue?.nominalRef;
        break;
      case "DUU":
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
      case "PIN":
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        baseData.supplierRef = suppliervalue.supplierRef;
        baseData.branchId = branch.branchId;
        baseData.nominalRef = nominal.nominalRef;
        break;
      case "DIN":
        baseData.supplierRef = suppliervalue.supplierRef;
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
      default:
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
    }

    if (data[0].postingType !== "PIN") {
      data[0].branchId = undefined;
    }
    if (IS_MODAL) {
      if (
        props.activityData?.unallocatedOnly &&
        !props.activityData?.chitRequestId
      ) {
        data[0].matterID = matterref ?? undefined;
        data[0].unallocated = true;
      } else {
        data[0].matterID = props.matter?.matterId;
      }
    }

    // Check if we're in edit mode (chitRequestId exists) or create mode
    if (props.activityData && props.activityData.chitRequestId) {
      // Edit mode - use direct API call with toast
      try {
        setLoading(true);
        await updateChitRequest(props.activityData.chitRequestId, data[0]);
        toast.success("Chit request updated successfully!");
        props.setModal && props.setModal(false);
        props.cancelEdit(true); // Pass true to indicate data was modified
      } catch (error) {
        console.error("Error updating chit request:", error);
      } finally {
        setLoading(false);
      }
      return; // Exit early for edit mode
    } else {
      try {
        await createChitRequestAPI(data);
        toast.success("Chit request created successfully!");
        if (IS_MODAL) {
          props.cancelEdit && props.cancelEdit(true);
        } else {
          resetfields();
        }
      } catch (error) {
        console.error("Error creating chit request:", error);
      } finally {
        setLoading(false);
      }
    }
    // setresetmatter(!resetmatter);
  };

  const handleRejectChit = async () => {
    if (!rejectionReason.trim()) {
      toast.error("Please provide a rejection reason");
      return;
    }

    try {
      setLoading(true);
      await rejectChitRequest(props.activityData.chitRequestId, {
        rejectReason: rejectionReason,
      });
      toast.success("Chit request rejected successfully!");
      setShowRejectModal(false);
      setRejectionReason("");
      props.cancelEdit(true); // Pass true to indicate data was modified (rejected)
    } catch (error) {
      console.error("Error rejecting chit request:", error);
    } finally {
      setLoading(false);
    }
  };
  const resetfields = () => {
    // BatchPosting pattern: reset to initial defaults
    setvalidation_message(false);
    setgrossamount("");
    setstate("");
    setvatamount("");
    setpayee("");
    setpayer("");
    setdetails("");
    setBankName("");
    setSortCode("");
    setAccountNumber("");
    setNotes("");
    setnetamount(0);
    setdateselector(new Date());
    setcounselfee(false);

    // Reset complex objects to initial state
    setvatvalue(null);
    setofficevalue(null);
    setclientvalue(null);
    setddavalue(null);
    setsuppliervalue({ supplierRef: "" });
    setnominal({ nominalRef: "" });
    setbranch({ branchId: "" });
    setfeeearnerref(null);

    // Reset matter if not in modal mode (BatchPosting pattern)
    if (!IS_MODAL) {
      setmatterref(null);
      setMatter(null);
      setMatterBalanceClear(true);
      dispatch(clearMattersBalances("Chit Request"));
    }

    // Reset dropdown data to full lists
    if (suppliersdata?.length > 0) setsuppliersdata(suppliersdata.slice());
    if (activevatsdata?.length > 0) setvatsData(activevatsdata.slice());
    if (feeearnerdata?.length > 0) setfeeearnerData(feeearnerdata.slice());

    // Reset documents
    setresetDocs(!resetDocs);
    setFilesData([]);
    clearChitFile();
  };

  const { isSuccess, uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);
    const parameters = {
      documentType: "Posting",
      matterId: matter?.matterId || "",
      supplierRef: suppliervalue?.supplierRef || "",
      nominalRef: nominal?.nominalRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
    addChitFile(dataChoosen);
  };
  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const comboBoxesInfo = [
    {
      key: "SupplierRef",
      label: "Supplier Ref",
      condition: suppliervalue.supplierRef === "",
      data: suppliersdata,
      onFilterChange: filterChangesupplier,
      value: suppliervalue,
      onChange: onChangesupplier,
      field: "display",
      placeholder: "Search Supplier Ref",
    },
    {
      key: "NominalRef",
      label: "Nominal Ref",
      condition: nominal.nominalRef === "",
      data: nominaldata,
      onFilterChange: filternominal,
      value: nominal,
      onChange: onChangenominal,
      placeholder: "Search Nominal Ref",
    },
  ];

  const ChitRequestContent = () => {
    return (
      <div
        className={`${!IS_MODAL ? "vh-100" : "mx-4 h-100"} ${styles["main-container"]
          }`}
        style={{ position: "relative" }}
      >
        {isLoadingChitData && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div className="text-center">
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div>Loading Chit Request data...</div>
            </div>
          </div>
        )}
        <div className="bgForm overflow-auto">
          <div
            className="px-5 "
            style={{
              maxHeight: !IS_MODAL ? "calc(100vh - 130px)" : "auto",
              overflow: "auto",
            }}
          >
            <form onSubmit={handlesubmit}>
              <div className="d-flex mt-4">
                <div
                  className="d-flex flex-column me-5"
                // style={{ marginTop: "1.55rem" }}
                >
                  <div className="d-flex flex-column">
                    <Label className="label mb-1">Posting Type</Label>
                    <DropDownList
                      className={`mb-1 ${styles["input-styles"]}`}
                      style={{
                        border:
                          validation_message && !type
                            ? "1px solid red"
                            : undefined,
                      }}
                      data={postingTypes}
                      textField={"display"}
                      iconClassName="wa"
                      dataItemKey="code"
                      value={type}
                      onChange={handleChange}
                      placeholder="Select Type"
                      disabled={IS_MODAL && props.activityData?.chitRequestId}
                    />
                  </div>

                  <div className="d-flex flex-column mt-1">
                    <Label className="label mb-1">Matter</Label>
                    <MattersCombobox
                      className={`${styles["input-styles"]}`}
                      onChangematter={onChangematter}
                      disabled={
                        IS_MODAL &&
                        (Boolean(props.activityData?.chitRequestId) ||
                          !props.activityData?.unallocatedOnly)
                      }
                      error={
                        validation_message &&
                        !matterref &&
                        !props.activityData?.unallocatedOnly
                      }
                      value={
                        IS_MODAL
                          ? props.activityData?.unallocatedOnly
                            ? matterref
                              ? matter
                              : null
                            : props.matter
                          : matterref
                            ? matter
                            : null
                      }
                    />
                  </div>
                  <div className="d-flex flex-column mt-1 ">
                    <Label className="label mb-1">Date</Label>
                    <DatePicker
                      className={`${styles["input-styles"]} px-2`}
                      value={dateselector}
                      width={280}
                      onChange={onChangedateselect}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>

                <div className="pe-1 d-flex flex-column gap-1 ">
                  <div className="">
                    <MatterDetails matter={matter} clear={matterBalanceClear} />
                  </div>
                  <div className="mt-2 mb-2">
                    <MatterAccount
                      component={"Chit Request"}
                      clear={matterBalanceClear}
                      matterId={matter?.matterId}
                    // width={"700px"}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <div className="d-flex mb-2">
                  {list.includes("Reference") && (
                    <div
                      className="d-flex flex-column me-3"
                      style={{
                        minWidth: "360px",
                      }}
                    >
                      <Label className="label mb-1">Reference</Label>
                      <Input
                        className={`${styles["input-styles"]}`}
                        value={state}
                        onChange={(e) => {
                          setstate(e.target.value);
                        }}
                        placeholder={"Add Reference"}
                      />
                    </div>
                  )}
                  {list.includes("Payee") && (
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">Payee</Label>
                      <Input
                        className={`${styles["input-styles"]}`}
                        style={{
                          border:
                            validation_message && !payee ? "1px solid red" : "",
                        }}
                        value={payee}
                        onChange={(e) => {
                          setpayee(e.target.value);
                        }}
                        placeholder={"Add Payee"}
                      />
                    </div>
                  )}
                  {list.includes("Payer") && !list.includes("Payee") && (
                    <div className="d-flex flex-column" style={{ flex: "1" }}>
                      <Label className="label mb-1">Payer</Label>
                      <Input
                        value={payer}
                        className={`${styles["input-styles"]}`}
                        style={{
                          border:
                            validation_message && !payer ? "1px solid red" : "",
                        }}
                        onChange={(e) => {
                          setpayer(e.target.value);
                        }}
                        placeholder={"Add Payer"}
                      />
                    </div>
                  )}
                </div>

                {list.includes("Payer") && list.includes("Payee") && (
                  <div className="d-flex mb-2">
                    <div
                      className="d-flex flex-column me-3"
                      style={{ minWidth: "360px" }}
                    >
                      <Label className="label mb-1">Payer</Label>
                      <Input
                        value={payer}
                        className={`${styles["input-styles"]}`}
                        style={{
                          border:
                            validation_message && !payer ? "1px solid red" : "",
                        }}
                        onChange={(e) => {
                          setpayer(e.target.value);
                        }}
                        placeholder={"Add Payer"}
                      />
                    </div>
                    <div style={{ flex: "1" }}></div>
                  </div>
                )}

                {list.includes("NetAmount") && (
                  <div className="d-flex mb-2">
                    <div
                      className="d-flex flex-column me-3"
                      style={{ minWidth: "360px" }}
                    >
                      <Label className="label mb-1">Net amount</Label>
                      <NumericTextBox
                        value={netamount}
                        className={`${styles["input-styles"]}`}
                        style={{
                          border:
                            validation_message &&
                            (netamount === 0 || netamount === "") &&
                            "1px solid red",
                        }}
                        inputStyle={{ textAlign: "right" }}
                        onChange={(e) => {
                          setnetamount(e.target.value);
                          if (vatvalue !== undefined) {
                            calculatevatamount();
                          }
                        }}
                        spinners={false}
                        format="n2"
                        placeholder="0.00"
                      />
                    </div>
                    <div style={{ flex: "1" }}></div>
                  </div>
                )}

                {list.includes("VatCode") && (
                  <div className="d-flex mb-1">
                    <div
                      className="d-flex flex-column me-3"
                    // style={{ width: "360px" }}
                    >
                      <Label className="label mb-1">VAT</Label>
                      <ComboBox
                        className={`${styles["small-inputbox"]}`}
                        style={{
                          border:
                            validation_message &&
                              type.code !== "ODR" &&
                              type.code !== "OCR" &&
                              type.code !== "CDR" &&
                              type.code !== "CCR" &&
                              type.code !== "DDR" &&
                              type.code !== "DCR" &&
                              vatvalue === undefined
                              ? "1px solid red"
                              : undefined,
                        }}
                        data={activevatsdata}
                        textField={"display"}
                        filterable={true}
                        onFilterChange={filterChange}
                        value={vatvalue}
                        onChange={onChangevat}
                        placeholder={"Code"}
                      />
                    </div>
                    {list.includes("VatAmount") && (
                      <div className="d-flex mb-2">
                        <div
                          className="d-flex flex-column me-3"
                          style={{ minWidth: "360px" }}
                        >
                          <Label className="label mb-1">VAT Amount</Label>
                          <NumericTextBox
                            className={`${styles["small-inputbox"]}`}
                            value={vatamount}
                            readOnly={true}
                            placeholder="0.00"
                            spinners={false}
                            format="n2"
                            inputStyle={{ textAlign: "right" }}
                          />
                        </div>
                      </div>
                    )}
                    {/* <div style={{flex: "1"}}></div> */}
                  </div>
                )}

                {list.includes("FeeEarnerRef") && (
                  <div className="d-flex mb-3">
                    <div
                      className="d-flex flex-column me-3"
                      style={{ minWidth: "360px" }}
                    >
                      <Label className="label mb-1">Fee Earner</Label>
                      <ComboBox
                        className={`${styles["input-styles"]}`}
                        style={{
                          border:
                            validation_message && !feeearnerref
                              ? "1px solid red"
                              : undefined,
                        }}
                        data={feeearner}
                        iconClassName="wa"
                        textField={`display`}
                        filterable
                        onFilterChange={filterfeeearner}
                        placeholder={"Search Fee Earner"}
                        value={feeearnerref}
                        onChange={onChangefeeearner}
                      />
                    </div>
                    {comboBoxesInfo.some(({ key }) => list?.includes(key)) ||
                      list.includes("BankName") ||
                      (list.includes("BankAccountNo") &&
                        list.includes("BankSortCode")) ? (
                      <div className="d-flex">
                        {comboBoxesInfo.some(({ key }) =>
                          list?.includes(key)
                        ) && (
                            <div
                              className="d-flex flex-column me-3"
                              style={{ width: "360px" }}
                            >
                              {comboBoxesInfo.map(
                                ({
                                  key,
                                  label,
                                  condition,
                                  data,
                                  onFilterChange,
                                  value,
                                  onChange,
                                  field,
                                  placeholder,
                                }) =>
                                  list?.includes(key) ? (
                                    <div key={key}>
                                      <ComboBoxComponent
                                        label={label}
                                        className={`${styles["input-styles"]}`}
                                        style={{
                                          border:
                                            validation_message && condition
                                              ? "1px solid red"
                                              : "",
                                        }}
                                        data={data}
                                        textField={field || "display"}
                                        filterable={true}
                                        onFilterChange={onFilterChange}
                                        value={value}
                                        onChange={onChange}
                                        placeholder={placeholder}
                                      />
                                    </div>
                                  ) : null
                              )}
                            </div>
                          )}
                        <div
                          className="d-flex flex-column"
                          style={{ flex: "1", marginTop: "-70px" }}
                        >
                          {list.includes("BankName") && (
                            <div className="d-flex flex-column me-3">
                              <Label className="label mb-1">Bank Name</Label>
                              <Input
                                className={`${styles["input-styles"]}`}
                                style={{
                                  border:
                                    validation_message && !bankName
                                      ? "1px solid red"
                                      : "",
                                }}
                                value={bankName}
                                onChange={(e) => {
                                  setBankName(e.target.value);
                                }}
                                placeholder={"Enter Bank Name"}
                              />
                            </div>
                          )}
                          {list.includes("BankAccountNo") &&
                            list.includes("BankSortCode") && (
                              <div className="d-flex mt-2">
                                <div className="d-flex flex-column me-3">
                                  <Label className="label mb-1">
                                    Sort Code
                                  </Label>
                                  <Input
                                    className={`${styles["small-inputbox"]}`}
                                    style={{
                                      border:
                                        validation_message && !sortCode
                                          ? "1px solid red"
                                          : "",
                                    }}
                                    value={sortCode}
                                    onChange={(e) => {
                                      setSortCode(e.target.value);
                                    }}
                                    placeholder={"Enter Sort Code"}
                                  />
                                </div>
                                <div className="d-flex flex-column">
                                  <Label className="label mb-1">
                                    Account Number
                                  </Label>
                                  <Input
                                    className={`${styles["small-inputbox"]}`}
                                    style={{
                                      border:
                                        validation_message && !accountNumber
                                          ? "1px solid red"
                                          : "",
                                    }}
                                    value={accountNumber}
                                    onChange={(e) => {
                                      setAccountNumber(e.target.value);
                                    }}
                                    placeholder={"Enter Account Number"}
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}

                <div className="d-flex">
                  <div
                    className="d-flex flex-column me-3"
                    style={{ minWidth: "360px" }}
                  >
                    <Label className="label mb-1">Details</Label>
                    <TextArea
                      value={details}
                      className={`${styles["details-textbox"]}`}
                      style={{
                        border:
                          validation_message === true && !details
                            ? "1px solid red"
                            : "",
                        height: "80px",
                      }}
                      rows={3}
                      multiple={true}
                      placeholder="Enter Details"
                      onChange={(e) => {
                        setdetails(e.target.value);
                      }}
                    />
                    <div
                      className=" d-flex align-items-start justify-content-between mt-2"
                      style={{ width: "326px" }}
                    >
                      <div className="d-flex">
                        {list.includes("IsCounselFee") && (
                          <div className="d-flex gap-1 align-items-center mt-2">
                            <Checkbox
                              className="me-2"
                              value={counselfee}
                              onChange={(e) => setcounselfee(e.value)}
                            />
                            <Label
                              htmlFor="isCounselFee"
                              className="label mb-0"
                            >
                              Counsel Fee
                            </Label>
                          </div>
                        )}
                      </div>
                      <div className="">
                        <DocumentsUpload
                          open={documentUpload}
                          value={type}
                          type={"Chit Request"}
                          resetDocs={resetDocs}
                          progress={progress}
                          filesData={filesData}
                          onFileRemove={onFileRemove}
                          onError={() => {
                            const newFiles = filesData.splice(
                              filesData.length,
                              1
                            );
                            setFilesData([...newFiles]);
                          }}
                          onUpload={handleUpload}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column" style={{ minWidth: '360px' }}>
                    <Label className="label mb-1">Notes</Label>
                    <TextArea
                      value={notes}
                      style={{
                        border:
                          validation_message && !notes ? "1px solid red" : "",
                        height: "80px",
                      }}
                      rows={3}
                      multiple={true}
                      placeholder="Enter Notes"
                      onChange={(e) => {
                        setNotes(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              {!IS_MODAL && (
                <div className={`my-2 d-flex justify-content-end`}>
                  <Button
                    className="common-btn bgBtnSecondary me-3"
                    type="button"
                    onClick={() => {
                      resetfields();
                    }}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    id="chit-request-post"
                    className="common-btn"
                    isLoading={loading}
                    disabled={loading}
                    type="submit"
                  >
                    {props.activityData?.chitRequestId ? "Update" : "Post"}
                  </SubmitButton>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return ChitRequestContent();
  };

  return (
    <>
      {showRejectModal && (
        <Dialog
          title="Reject Chit Request"
          onClose={() => {
            setShowRejectModal(false);
            setRejectionReason("");
          }}
          width={450} // style={{ width: "400px" }}
        >
          <div className="p-3">
            <Label className="label mb-2 d-block">Rejection Reason</Label>
            <TextArea
              className="w-100"
              rows={5}
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.value)}
              placeholder="Enter reason for rejection..."
              style={{
                height: "80px",
                resize: "none",
                maxWidth: "100%",
                border:
                  !rejectionReason.trim() && rejectionReason !== ""
                    ? "1px solid red"
                    : undefined,
              }}
            />
          </div>
          {/* <DialogActionsBar> */}
          <div className="d-flex justify-content-end w-100 gap-2 dialog-footer">
            <Button
              className="common-btn bgBtnSecondary"
              onClick={() => {
                setShowRejectModal(false);
                setRejectionReason("");
              }}
              disabled={loading}
            >
              Cancel
            </Button>
            <SubmitButton
              className="common-btn me-3"
              onClick={handleRejectChit}
              disabled={loading || !rejectionReason.trim()}
              isLoading={loading}
            >
              {loading ? "Rejecting..." : "Reject"}
            </SubmitButton>
          </div>
          {/* </DialogActionsBar> */}
        </Dialog>
      )}

      {IS_MODAL ? (
        <Dialog
          title={
            props.activityData?.chitRequestId
              ? "Edit Chit Request"
              : props.activityData?.unallocatedOnly
                ? "Chit Posting - Unallocated"
                : "Chit Request"
          }
          onClose={() => props.cancelEdit(false)}
          className="dialog-xl"
        >
          {renderContent()}
          <DialogActionsBar>
            <div
              className={`d-flex justify-content-between w-100 dialog-footer`}
            >
              <div>
                {props.activityData?.chitRequestId && !isRejectedChit && (
                  <Button
                    className="common-btn bgBtnSecondary ms-4"
                    type="button"
                    onClick={() => setShowRejectModal(true)}
                    disabled={loading}
                  >
                    Reject Chit
                  </Button>
                )}
              </div>
              <div>
                <Button
                  className="common-btn bgBtnSecondary me-3"
                  type="button"
                  onClick={() => {
                    resetfields();
                    if (IS_MODAL) props.cancelEdit(false); // Pass false when cancelling without changes
                  }}
                >
                  Cancel
                </Button>
                <SubmitButton
                  className="me-3"
                  id="chit-request-post"
                  type="submit"
                  onClick={handlesubmit}
                  isLoading={loading}
                  disabled={loading}
                >
                  {props.activityData?.chitRequestId ? "Update" : "Post"}
                </SubmitButton>
              </div>
            </div>
          </DialogActionsBar>
        </Dialog>
      ) : (
        renderContent()
      )}
    </>
  );
};
export default ChitRequest;
